import React from 'react';
import styled from 'styled-components';
import UserIcon from '@catalogo/ui-americanas-desktop-svg/user-red.svg';

const NotLogged = () => (
  <Bg>
    <Box>
      <UserIcon width="50px" height="50px" />
      <Text>Descubra a experiência personalizada que a gente fez pra você :)</Text>
      <Button href="https://cliente.americanas.com.br/minha-conta/entrar?chave=0_0_up_0_0_tooltipcomplogin">
        fazer login
      </Button>
    </Box>
  </Bg>
);

const Bg = styled.div`
  background-image: url('https://images-americanas.b2w.io/spacey/acom/2021/01/13/not-logged-bg-desk.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  position: relative;
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  height: 135px;
  width: 820px;
  border-radius: 4px;
  background: ${({ theme }) => theme.white};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 100px;
  svg {
    width: 52px;
    height: 52px;
    flex: 0 0 52px;
  }
`;

const Text = styled.p`
  color: ${({ theme }) => theme.grey.dark};
  font-size: 18px;
  margin-left: 15px;
  flex: 0 0 326px;
`;

const Button = styled.a`
  height: 42px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 208px;
  border-radius: 3px;
  color: ${({ theme }) => theme.white};
  font-size: 16px;
  font-weight: bold;
  background: ${({ theme }) => theme.primaryColor};
  margin-left: 15px;
`;

export default NotLogged;
